// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3QfYg","choiceBoxes":"toolbarselects_choiceBoxes__UOoes","simpleField":"toolbarselects_simpleField__2z-4m"};